export default __webpack_public_path__ + "static/media/pro-elevate-wht-1.c1fe236a.png";